export default __webpack_public_path__ + "static/media/6.425cd2af.jpg";